import { useState } from 'react';
import { PopupModal } from 'react-calendly';

export const useCalendly = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openCalendly = () => setIsOpen(true);
  const closeCalendly = () => setIsOpen(false);

  const CalendlyModal = () => (
    <PopupModal
      url="https://calendly.com/caracciolo-ryan/30min"
      onModalClose={closeCalendly}
      open={isOpen}
      rootElement={document.getElementById('root')}
    />
  );

  return { openCalendly, CalendlyModal };
};
